<div class="overlay" *ngIf="isOpen" (click)="closePanel()"></div>
<div class="survey-panel" [ngClass]="{'visible': isOpen}">
  <div class="survey-header">
    <div class="title">{{ 'label.case_closure_survey' | translate }}</div>
    <div class="x-close">
      <i class="bi bi-x-lg" (click)="closePanel()"></i>
    </div>
  </div>

  <div class="survey-form-wrapper">
    <form class="survey-content row" [formGroup]="surveyForm">
      <div class="row">
        <div class="col-12 col-md-6">
          <app-select-form-field formControlName="ticketOwnerId" [label]="'survey.fields.caseOwnerId.label' | translate"
            [clearable]="true" [searchable]="true" [items]="ownerUsers" [bindValue]="'id'" [bindLabel]="'fullName'"
            [viewMode]="true"></app-select-form-field>
        </div>
        <div class="col-12 col-md-6">
          <app-select-form-field formControlName="internalCaseContactId"
            [label]="'survey.fields.internalCaseContactId.label' | translate" [clearable]="true" [searchable]="true"
            [items]="internalCaseUsers" [bindValue]="'id'" [bindLabel]="'fullName'" [viewMode]="true"></app-select-form-field>
        </div>
        <div class="col-12 col-md-6">
          <app-select-form-field formControlName="tsmNotifiedId"
            [label]="'survey.fields.tsmNotifiedId.label' | translate" [clearable]="true" [searchable]="true"
            [items]="internalCaseUsers" [bindValue]="'id'" [bindLabel]="'fullName'" [viewMode]="true"></app-select-form-field>
        </div>
        <div class="col-12 col-md-6">
          <app-datepicker-form-field formControlName="date" [label]="'survey.fields.date.label' | translate"
            [viewMode]="true"></app-datepicker-form-field>
        </div>
      </div>
    </form>

    <form [formGroup]="surveyForm">
      <app-case-form-section-container [iconClass]="'bi bi-chat-left-text'" [title]="'label.provide_feedback'">
        <div class="question">
          <app-radio-form-field [name]="'q1'" [options]="yesNoOptions" [label]="'survey.labels.q1' | translate"
            [isRequired]="true" formControlName="q1SelectAnswer"></app-radio-form-field>
          <app-textarea-form-field formControlName="q1TextAnswer" [isLabelTopPosition]="true"
            [placeholder]="'placeholders.add_your_comment' | translate" [label]="''" [viewMode]="false">
          </app-textarea-form-field>
        </div>
        <div class="question">
          <app-radio-form-field [name]="'q2'" [options]="satisfiedOptions" [label]="'survey.labels.q2' | translate"
            [isRequired]="true" formControlName="q2SelectAnswer"></app-radio-form-field>
          <app-textarea-form-field formControlName="q2TextAnswer" [isLabelTopPosition]="true"
            [placeholder]="'placeholders.add_your_comment' | translate" [label]="''" [viewMode]="false">
          </app-textarea-form-field>
        </div>
        <div class="question">
          <app-radio-form-field [name]="'q3'" [options]="satisfiedOptions" [label]="'survey.labels.q3' | translate"
            [isRequired]="true" formControlName="q3SelectAnswer"></app-radio-form-field>
          <app-textarea-form-field formControlName="q3TextAnswer" [isLabelTopPosition]="true"
            [placeholder]="'placeholders.add_your_comment' | translate" [label]="''" [viewMode]="false">
          </app-textarea-form-field>
        </div>
        <div class="question">
          <app-radio-form-field [name]="'q4'" [options]="yesNoOptions" [label]="'survey.labels.q4' | translate"
            [isRequired]="true" formControlName="q4SelectAnswer"></app-radio-form-field>
          <app-textarea-form-field formControlName="q4TextAnswer" [isLabelTopPosition]="true"
            [placeholder]="'placeholders.add_your_comment' | translate" [label]="''" [viewMode]="false">
          </app-textarea-form-field>
        </div>
        <div class="question">
          <app-radio-form-field [name]="'q5'" [options]="satisfiedOptions" [label]="'survey.labels.q5' | translate"
            [isRequired]="true" formControlName="q5SelectAnswer"></app-radio-form-field>
          <app-textarea-form-field formControlName="q5TextAnswer" [isLabelTopPosition]="true"
            [placeholder]="'placeholders.add_your_comment' | translate" [label]="''" [viewMode]="false">
          </app-textarea-form-field>
        </div>
      </app-case-form-section-container>
    </form>
  </div>
  <div class="survey-footer">
    <button class="btn" (click)="closePanel()"> {{ 'buttons.cancel' | translate }} </button>
    <button class="btn btn--confirm" (click)="submitSurvey()" [disabled]="!surveyForm.valid"> {{ 'buttons.submit' | translate }} </button>
  </div>
